import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

/**
 * @name login
 * @description Login to the system
 * @param {object} data
 * @param {string} data.email
 * @param {string} data.password
 * @response success - 200 OK
 * @response failure - 401 Unauthorized
 * @returns {object} response.data
 *
 * @requires setAuthToken
 */
export const login = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/login', data);
  if (!isApiResponseError(response)) {
    apiClient.setAuthToken(response.data?.data?.access_token);
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name register
 * @description Register a new user
 * @param {object} data
 * @param {string} data.email
 * @param {string} data.password
 * @param {string} data.name
 * @response success - 200 OK
 * @response failure - 400 Bad Request
 * @returns {object} response.data
 *
 * @constant role only is 'therapist
 */
export const register = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/register', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name resetPassword
 * @description Reset the password of a user
 * @param {object} data
 * @param {string} data.email
 * @response success - 200 OK
 * @response failure - 400 Bad Request
 * @returns {object} response.data
 */
export const resetPassword = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/reset-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name confirmResetPassword
 * @description Confirm the reset password of a user
 * @param {object} data
 * @param {string} data.email
 * @param {string} data.token
 * @response success - 200 OK
 * @response failure - 400 Bad Request
 * @returns {object} response.data
 */
export const confirmResetPassword = async (data) => {
  const response = await apiClient.request('POST', '/admin/auth/confirm-reset-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

/**
 * @name getListData
 * @description Get the list of data
 * @param {string} query
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const getListFacility = async (query) => {
  const response = await apiClient.request('GET', `/admin/facilities${query}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

